import React from "react";
import LegalLayout from "../components/LegalLayout";

const PrivacyRequestsPage: React.FC = () => (
  <LegalLayout
    title="Privacy Requests"
    path="/privacy-requests"
    description="How to submit a privacy request to PABS to access, correct, or delete your personal information."
    intro="How to submit a request to access, correct, or delete your personal information."
  >
        <p>
          You may request access to, deletion of, or export of certain personal information, subject to verification
          and applicable law.
        </p>

        <h2>How to submit a request</h2>
        <ul>
          <li>Email <a href="mailto:privacy@pabs.online">privacy@pabs.online</a> from the address associated with your account.</li>
          <li>Include the type of request (access, deletion, export) and any relevant details.</li>
        </ul>

        <h2>Verification</h2>
        <p>
          To protect your account, we may ask you to verify your identity before completing a request.
        </p>

        <h2>Related pages</h2>
        <p>
          See our <a href="/privacy">Privacy Statement</a> and <a href="/security">Security</a>.
        </p>

        <p className="legal-note">
          This page is provided for general informational purposes and may be updated from time to time.
        </p>
  </LegalLayout>
);

export default PrivacyRequestsPage;
